import { types } from 'mobx-state-tree';

import AccidentClaimTypeValues from '../definitions/AccidentClaimTypeValues';


const AccidentClaim = types
    .model('AccidentClaim', {
        id: types.identifier,
        type: types.enumeration(Object.values(AccidentClaimTypeValues)),
        date: types.string,
    });

export default AccidentClaim;
